// extracted by mini-css-extract-plugin
export default {"addPlayList":"BtnAddPlayList_addPlayList__Eeetm","bottomPlayer":"BtnAddPlayList_bottomPlayer__w5OXX"};